import{jsxs as e,jsx as i}from"react/jsx-runtime";import{MdAttachFile as o}from"../../../../node_modules/@react-icons/all-files/md/MdAttachFile.js";import{MdCameraAlt as t}from"../../../../node_modules/@react-icons/all-files/md/MdCameraAlt.js";import{MdKeyboardVoice as r}from"../../../../node_modules/@react-icons/all-files/md/MdKeyboardVoice.js";import n from"styled-components";import{useTranslation as d}from"react-i18next";import{EmojiIcon as l}from"../../../../icons/chatWidget/bottomBar/EmojiIcon.js";import{withTranslations as s}from"../../../../services/translations/withTranslations.js";import{RobotoFontStyle as a}from"../../../../style/fonts/robotoFont.js";const c=n.div`
  display: flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 5px;
  height: 100%;
`,m=n.input`
  border: 0;
  font-size: 16px;
  margin: 0;
  outline: none;
  min-width: 50px;
  height: 100%;
`,p=n.div`
  background: #008a7c;
  border-radius: 50%;
  color: #fff;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex: 0 0 auto;
  margin-left: 8px;
`,f=n.div`
  margin-right: 12px;
  height: 100%;
  display: flex;
  align-items: center;
`,x=n(t)`
  display: block;
  color: #7d8488;
  font-size: 24px;
`,h=n(o)`
  display: block;
  color: #7d8488;
  font-size: 24px;
  transform: rotate(-30deg);
`,g=n.div`
  ${a}
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  height: 50px;
  width: calc(100% - 16px);
  padding: 2px 8px 5px;
  z-index: 2;
  box-sizing: content-box;
`,b=n.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  height: 40px;
  width: 100%;
  z-index: 2;
  background: #fff;
  border-radius: 40px;
`,u=s((()=>{const{t:o}=d();return e(g,{children:[e(b,{children:[i(c,{children:i(l,{})}),i(m,{placeholder:o("common.typeMessage")}),i(f,{children:i(h,{})}),i(f,{children:i(x,{})})]}),i(p,{children:i(r,{})})]})}));export{u as BottomBar};
//# sourceMappingURL=BottomBar.js.map
